import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { paidClassConfig } from './PaidClass.name';

/** 支払済のENUM */
enum PaidClass {
  /** 未 */
  notYet = '1',
  /** 済 */
  completed = '2',
}

const paidClassMap = new Map([
  ['1', PaidClass.notYet],
  ['2', PaidClass.completed],
]);

const rawValueToPaidClass = rawValueToEnumWithDefault(paidClassMap, PaidClass.notYet);

const paidClassToDisplay = enumToNameWithDefault(PaidClass, paidClassConfig);

export { PaidClass, paidClassToDisplay, rawValueToPaidClass };
